// helpers/translation/index.js
import EN from './en.js';
import DE from './de.js';
import IT from './it.js';
import FR from './fr.js';
import ES from './es.js';
import PT from './pt.js';
import NL from './nl.js';
import DA from './da.js';
import PL from './pl.js';
import UA from './ua.js';

export const MESSAGES = {
  en: EN,
  de: DE,
  it: IT,
  fr: FR,
  es: ES,
  pt: PT,
  nl: NL,
  da: DA,
  pl: PL,
  ua: UA, // залишаємо 'ua' — як ти хочеш
};

// просте нормалізування: trim + toLowerCase + зрізати суфікс (en-US -> en)
export function normalizeLang(v) {
  const key = String(v || 'en')
    .trim()
    .toLowerCase();
  return key.split('-')[0];
}

// глибоке злиття без бібліотек (фолбек на EN)
function deepMerge(base, override) {
  if (override == null || typeof override !== 'object') return base;
  const out = Array.isArray(base) ? [...base] : { ...base };
  for (const [k, v] of Object.entries(override)) {
    if (
      v &&
      typeof v === 'object' &&
      !Array.isArray(v) &&
      typeof base?.[k] === 'object' &&
      !Array.isArray(base[k])
    ) {
      out[k] = deepMerge(base[k], v);
    } else {
      out[k] = v;
    }
  }
  return out;
}

export function getTranslation(lang) {
  const key = normalizeLang(lang);
  const pack = MESSAGES[key] || MESSAGES.en;
  // завжди повертаємо EN як базу + поверх нього переклади конкретної мови
  return deepMerge(EN, pack);
}

export default MESSAGES;
